import React from "react";
import loadingImg from "../../images/square-loading.jpg";
import { ReactComponent as CrescoIcon } from "../../images/cresco-logo-icon.svg";

const LoadingSquareCard = () => (
  <div className="loading-square">
    <img src={loadingImg} className="loading-square-image" />
    <div className="loading-icon">
      <CrescoIcon
        style={{
          position: "absolute",
          color: "#ffffff",
          top: "calc(50% - 25px)",
          left: "calc(50% - 25px)",
          width: "50px",
          height: "50px",
        }}
      />
    </div>
  </div>
);

export default LoadingSquareCard;
